(function () {
  'use strict';

  function initialiseCarousel(root) {
    if (!root || root.dataset.bvmCcbCarouselReady === 'true') return;

    var rail = root.querySelector('[data-bvm-ccb-rail]');
    var previousButton = root.querySelector('[data-bvm-ccb-prev]');
    var nextButton = root.querySelector('[data-bvm-ccb-next]');

    if (!rail || !previousButton || !nextButton) return;

    root.dataset.bvmCcbCarouselReady = 'true';

    function getScrollStep() {
      var firstCard = rail.querySelector('.bvm-ccb-zero__card');
      if (!firstCard) return Math.max(rail.clientWidth * 0.8, 260);

      var railStyles = window.getComputedStyle(rail);
      var gap = parseFloat(railStyles.columnGap || railStyles.gap || '0') || 0;
      return firstCard.getBoundingClientRect().width + gap;
    }

    function updateButtons() {
      var maximumScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
      previousButton.disabled = rail.scrollLeft <= 2;
      nextButton.disabled = rail.scrollLeft >= maximumScroll - 2;
    }

    previousButton.addEventListener('click', function () {
      rail.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
    });

    nextButton.addEventListener('click', function () {
      rail.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
    });

    rail.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons, { passive: true });

    updateButtons();
    window.requestAnimationFrame(updateButtons);
  }

  function initialiseLightbox(root) {
    if (!root || root.dataset.bvmCcbLightboxReady === 'true') return;

    var lightbox = root.querySelector('[data-bvm-ccb-lightbox]');
    if (!lightbox) return;

    var image = lightbox.querySelector('[data-bvm-ccb-lightbox-image]');
    var title = lightbox.querySelector('[data-bvm-ccb-lightbox-title]');
    var closeButtons = lightbox.querySelectorAll('[data-bvm-ccb-lightbox-close]');
    var lastTrigger = null;
    var previousHtmlOverflow = '';
    var previousBodyOverflow = '';

    if (!image || !title) return;

    root.dataset.bvmCcbLightboxReady = 'true';

    function unlockPage() {
      document.documentElement.style.overflow = previousHtmlOverflow;
      document.body.style.overflow = previousBodyOverflow;
    }

    function closeLightbox() {
      if (lightbox.hidden) return;

      lightbox.hidden = true;
      image.removeAttribute('src');
      image.alt = '';
      title.textContent = '';
      unlockPage();

      if (lastTrigger && document.contains(lastTrigger)) {
        lastTrigger.focus();
      }
    }

    function openLightbox(trigger) {
      var source = trigger.dataset.bvmCcbLightboxSrc;
      if (!source) return;

      lastTrigger = trigger;
      previousHtmlOverflow = document.documentElement.style.overflow;
      previousBodyOverflow = document.body.style.overflow;

      image.src = source;
      image.alt = trigger.dataset.bvmCcbLightboxAlt || '';
      title.textContent = trigger.dataset.bvmCcbLightboxTitle || '';
      lightbox.hidden = false;

      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';

      var closeButton = lightbox.querySelector('.bvm-ccb-lightbox__close');
      if (closeButton) closeButton.focus();
    }

    root.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-bvm-ccb-lightbox-open]');
      if (!trigger || !root.contains(trigger)) return;
      openLightbox(trigger);
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeLightbox);
    });

    document.addEventListener('keydown', function (event) {
      if (!lightbox.hidden && event.key === "Escape") {
        closeLightbox();
      }
    });
  }

  function initialiseAll(scope) {
    var context = scope || document;
    var carousels = context.querySelectorAll('[data-bvm-ccb-carousel]');

    carousels.forEach(function (root) {
      initialiseCarousel(root);
      initialiseLightbox(root);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initialiseAll(document);
    });
  } else {
    initialiseAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialiseAll(event.target);
  });
})();
